// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../node_modules/postcss-loader/src/index.js!../../styleGuide.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".src-components-TextInput-TextInput__input--1QHwS{border:none;border-bottom:1rem solid #a6a6a7;width:100%;outline:none;font-family:Quicksand,sans-serif;margin-bottom:15rem;font-weight:700}.src-components-TextInput-TextInput__floatLabel--a9I2m{color:" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["neutralColor"] + ";margin-bottom:-2rem}", ""]);
// Exports
exports.locals = {
	"neutralColor": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["neutralColor"] + "",
	"input": "src-components-TextInput-TextInput__input--1QHwS",
	"floatLabel": "src-components-TextInput-TextInput__floatLabel--a9I2m"
};
module.exports = exports;
